'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Modal = function () {
	function Modal(modal_name) {
		var _this = this;

		_classCallCheck(this, Modal);

		this.modal_name = modal_name;
		this.$modal = $('.' + modal_name);
		this.$toggle = $('.' + this.modal_name + '-toggle');
		this.$active_location = $('.' + this.modal_name + '-location');

		this.$modal.addClass('detached');
		this.$toggle.on('click', function (e) {
			return _this.handleClick(e);
		});
	}

	_createClass(Modal, [{
		key: 'handleClick',
		value: function handleClick(e) {
			var _this2 = this;

			e.preventDefault();

			if (this.$modal.hasClass('detached')) {
				this.$active_location.append(this.$modal);
				this.$modal.removeClass('detached');
			}

			if (this.$modal.hasClass('active')) {
				this.$modal.css('display', 'none');
				$('body').css('overflow', 'initial');
			} else {
				this.$modal.css('display', 'flex');
				$('body').css('overflow', 'hidden');
			}

			setTimeout(function () {
				return _this2.$modal.toggleClass('active');
			}, 0);
		}
	}]);

	return Modal;
}();